var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 42",
    fill: "rgba(25, 27, 30, .8)",
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 4.972a21.35 21.35 0 0 1-6.126 1.669A10.635 10.635 0 0 0 50.565.777a21.41 21.41 0 0 1-6.778 2.569A10.673 10.673 0 0 0 36 0c-5.888 0-10.665 4.748-10.665 10.602 0 .832.092 1.639.275 2.415A30.34 30.34 0 0 1 3.62 1.935a10.539 10.539 0 0 0-1.444 5.337c0 3.676 1.883 6.922 4.746 8.824a10.726 10.726 0 0 1-4.834-1.322v.13c0 5.139 3.678 9.425 8.561 10.396-.894.249-1.837.373-2.811.373-.687 0-1.358-.063-2.008-.188a10.663 10.663 0 0 0 9.965 7.36 21.483 21.483 0 0 1-13.25 4.54c-.86 0-1.712-.048-2.545-.145A30.38 30.38 0 0 0 16.354 42c19.625 0 30.354-16.154 30.354-30.166 0-.461-.01-.922-.028-1.374A21.51 21.51 0 0 0 52 4.972Z"
  })));
};

export default SvgTwitter;